import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { CONSTANTS } from '../../utilities/Constants';
import { HttpWrapperService } from '../http-wrapper/http-wrapper.service';

@Injectable()
export class AuthService {

  constructor(private http: HttpWrapperService) { }

  validateToken(token) {
    let url = ApplicationUrlSettings.NODE_API_URL + "verify-token";
    return this.http.post(url, { token: token }).toPromise().then(res => res.json());
  }
  isValidLogin(): Promise<any> {

    var token = localStorage.getItem('token');

    var body = {
      token: token
    };

    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.IS_VALID_LOGIN;
    return this.http.post(url, JSON.stringify(body)).toPromise().then(res => res.json());

  }

  saveAdminPayload(payload) {
    localStorage.setItem('admin-payload', JSON.stringify(payload));
  }


  static getClientId() {
    try {
      var info = localStorage.getItem('admin-payload');
      if (!info) {
        return null;
      }
      var parsed = JSON.parse(info);
      return parsed.clientid;
    } catch (e) {
      console.log(e);
    }
  }

  static getCourierKey() {
    var payload = localStorage.getItem('admin-payload');
    if (payload) {
      return JSON.parse(payload).clientcode;
    } else {
      return null;
    }
  }



  getAdminPayload() {
    var payload = localStorage.getItem('admin-payload');
    if (payload) {
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  getClientCompanyId() {
    try {
      var payload = localStorage.getItem('admin-payload');
      if (payload) {
        return JSON.parse(payload).company_access[0].companyid;
      } else {
        return -1;
      }
    } catch (e) {
      return -1;
    }
  }

  hasOneOfRoles(roles: Array<string>) {
    var payload = this.getAdminPayload();
    if (payload) {
      for (var i = 0; i < roles.length; i++) {
        var r = roles[i];
        if (payload.roles_map[r]) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  refreshToken() {
    var url = `${ApplicationUrlSettings.NODE_API_URL}admin/refresh-token`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then((res => res.json()));
  }

  getRoles() {
    var url = `${ApplicationUrlSettings.NODE_API_URL}roles`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then((res => res.json()));
  }

  adminLogin(email, password): Promise<string> {

    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.ADMIN_LOGIN}`;
    console.log(url)
    return this.http.post(url, { email: email, password: password }).toPromise().then((res) => {
      return res.json()
    });

  }

  createAdmin(payload): Promise<string> {


    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CREATE_ADMIN;
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }
}
